import Utils from "context/utils";

// Every name below exists in blobhub 0.2.0. Specs: docs/specs/2026-10-07-sdk-notebooks-links.md,
// docs/specs/2026-10-18-remove-sdk-notebooks.md

// Anonymous on purpose: an org- or blob-scoped key cannot read public content, and a profile may hold one.
export const ONNX_DOWNLOAD_SNIPPET = [
  "import blobhub",
  "from blobhub.types.onnx import Onnx",
  "",
  "# Public models need no credentials",
  "hub = blobhub.connect(anonymous=True)",
  "",
  "# Find the blob and its default revision",
  'blob = hub.blob("onnx-vision-models", "super-resolution")',
  "revision = blob.revision()",
  "",
  "# Download the model, cached by revision",
  "path = Onnx(revision).download()",
].join("\n");

// The phases Api.canUpdateRevision admits; the platform refuses an upload into any other.
const WRITABLE_PHASES = ["draft", "managed"];

/**
 * The SDK snippet that uploads a model into the revision on screen, with the configured credential and never a key.
 * @param {{org: ?object, blob: object, revision: object}} target what the shell shows; `org` is null while loading
 */
export function onnxUploadSnippet({ org, blob, revision }) {
  const orgRef = Utils.aliasOrId(org) || blob.org_id;
  const revisionLines = WRITABLE_PHASES.includes(revision.phase)
    ? [`revision = blob.revision(${JSON.stringify(revision.id)})`]
    : [
      "# This revision is read-only, so upload into a new one",
      'revision = blob.create_revision("Upload a model")',
    ];
  return [
    "import blobhub",
    "from blobhub.types.onnx import Onnx",
    "",
    "# Reads BLOBHUB_API_KEY, or a profile saved by `blobhub login`",
    "hub = blobhub.connect()",
    `blob = hub.blob(${JSON.stringify(orgRef)}, ${JSON.stringify(Utils.aliasOrId(blob))})`,
    ...revisionLines,
    "",
    "# Packs the model, uploads it and waits for processing",
    'Onnx(revision).upload("/path/to/model.onnx")',
  ].join("\n");
}

/** Fences code as a python block, the form MarkdownBody highlights. */
export function pythonBlock(code) {
  return "```python\n" + code + "\n```";
}
